<div class="">
  <app-data-table [columns]="cols" [data]="userData"  [title]="tableTitle" [url]="'/account/users/'"
    (onAdd)="addUser()"  [isDeletable]="'/setup' | hasPermission: 'Delete'"
    [showAddButton]="'/setup' | hasPermission: 'Add'" [showActions]="canEditSetup"
    [isEditable]="'/setup' | hasPermission: 'Edit'" [isView]="'/setup' | hasPermission: 'View'"
    (viewEventRow)="viewSystem($event)" (editEventRow)="updateUser($event)"
    (deleteEventRow)="deleteUser($event)"></app-data-table>
</div>

<!-- <ng-container>
  <app-data-table [columns]="cols" [data]="userData" [isCardView]="false" (onPresentView)="getUserData()" [url]="'/account/users/'"
    [isDeletable]="'/master/section' | hasPermission: 'Delete'"  [showAddButton]="'/master/section' | hasPermission: 'Add'" [showActions]="canEditSetup" [isEditable]="'/master/section' | hasPermission: 'Edit'"   [title]="tableTitle" (onAdd)="addUser()" (editEventRow)="updateUser($event)" [isView]="'/master/section' | hasPermission: 'View'" (viewEventRow)="viewSystem($event)"
    (deleteEventRow)="deleteUser($event)" (onLazyLoadData)="getUserData($event)" [totalRecords]="totalRecords">
  </app-data-table>
</ng-container> -->


<p-dialog header="Add User" [(visible)]="showAddUserDialog" [modal]="true" [style]="{ width: '800px', height: 'auto' }"
  [maximizable]="true" appendTo="body">
  <form [formGroup]="userForm" (ngSubmit)="submitUserDetailsForm()" class="p-fluid form-wrapper">

    <!-- AD User Section -->
    <div class="row mb-4 num-field">
      <div class="p-field-checkbox col-md-2 ad-user">
        <p-checkbox formControlName="ad_user" binary="true" inputId="ad_user" class="custom-checkbox"></p-checkbox>
        <label for="ad_user">AD User</label>
      </div>

      <!-- Phone Field -->
      <div class="p-field col-md-6" *ngIf="userForm.get('ad_user')?.value">
        <label for="phone">Personal Number</label>
        <input id="phone" type="text" pInputText maxlength="10" formControlName="phone" inputmode="numeric" numericOnly
          pattern="[0-9]*" oninput="this.value = this.value.replace(/[^0-9]/g, '')" />
        <div *ngIf="userForm.get('phone')?.touched && userForm.get('phone')?.hasError('required')" class="text-danger">
          Phone number is required.
        </div>
      </div>

      <!-- Fetch Data Button -->
      <div class="col-md-4" *ngIf="userForm.get('ad_user')?.value">
        <button pButton label="Fetch Data from HRCDF" type="submit" [disabled]="!userForm.get('phone')?.value"
          class="fetch-data-btn" (click)="fetchData()"></button>
      </div>
    </div>

    <!-- Rank Code -->
    <div class="row mt-4">
      <div class="p-field col-md-4">
        <label for="rankCode">Rank Code*</label>
        <input id="rankCode" type="text" pInputText formControlName="rankCode" maxlength="255" required />
        <div *ngIf="userForm.get('rankCode')?.touched && userForm.get('rankCode')?.invalid" class="p-error mt-1">
          <small class="text-danger" *ngIf="userForm.get('rankCode')?.errors?.['required']">Rank Code is
            required.</small>
          <small class="text-danger" *ngIf="userForm.get('rankCode')?.errors?.['pattern']">Invalid Rank Code
            format.</small>
        </div>
      </div>

      <!-- Rank Name -->
      <div class="p-field col-md-4">
        <label for="rankName">Rank Name*</label>
        <input id="rankName" type="text" pInputText formControlName="rankName" maxlength="255" />
        <div *ngIf="userForm.get('rankName')?.touched && userForm.get('rankName')?.invalid" class="p-error mt-1">
          <small class="text-danger" *ngIf="userForm.get('rankName')?.errors?.['required']">Rank Name is
            required.</small>
          <small class="text-danger" *ngIf="userForm.get('rankName')?.errors?.['pattern']">Invalid Rank Name
            format.</small>
        </div>
      </div>

      <!-- First Name -->
      <div class="p-field col-md-4">
        <label for="first_name">First Name*</label>
        <input id="first_name" type="text" pInputText formControlName="first_name" maxlength="255" />
        <div *ngIf="userForm.get('first_name')?.touched && userForm.get('first_name')?.invalid" class="p-error mt-1">
          <small class="text-danger" *ngIf="userForm.get('first_name')?.errors?.['required']">First Name is
            required.</small>
          <small class="text-danger" *ngIf="userForm.get('first_name')?.errors?.['pattern']">First Name must contain
            only letters.</small>
        </div>
      </div>
    </div>

    <!-- Last Name -->
    <div class="row mt-4">
      <div class="p-field col-md-4">
        <label for="last_name">Last Name*</label>
        <input id="last_name" type="text" pInputText formControlName="last_name" maxlength="255" />
        <div *ngIf="userForm.get('last_name')?.touched && userForm.get('last_name')?.invalid" class="p-error mt-1">
          <small class="text-danger" *ngIf="userForm.get('last_name')?.errors?.['required']">Last Name is
            required.</small>
          <small class="text-danger" *ngIf="userForm.get('last_name')?.errors?.['pattern']">Last Name must contain only
            letters.</small>
        </div>
      </div>

      <!-- Email -->
      <div class="p-field col-md-4">
        <label for="email">Email*</label>
        <input id="email" type="email" pInputText formControlName="email" maxlength="255" />
        <div *ngIf="userForm.get('email')?.touched && userForm.get('email')?.invalid" class="p-error mt-1">
          <small class="text-danger" *ngIf="userForm.get('email')?.errors?.['required']">Email is required.</small>
          <small class="text-danger" *ngIf="userForm.get('email')?.errors?.['email']">Invalid email format.</small>
        </div>
      </div>

      <!-- Login Name -->
      <div class="p-field col-md-4">
        <label for="loginname">Login Name*</label>
        <input id="loginname" type="text" pInputText formControlName="loginname" maxlength="255" />
        <div *ngIf="userForm.get('loginname')?.touched && userForm.get('loginname')?.invalid" class="p-error mt-1">
          <small class="text-danger" *ngIf="userForm.get('loginname')?.errors?.['required']">Login Name is
            required.</small>
        </div>
      </div>
    </div>

    <!-- User Role and Unit -->
    <div class="row mt-4">
      <div class="p-field col-md-4">
        <label for="unit">Unit</label>
        <p-dropdown [options]="unitList" formControlName="unit" optionValue="id" optionLabel="name"
          placeholder="Select a User" [filter]="true" filterBy="name" class="w-100" appendTo="body">
        </p-dropdown>
      </div>

      <div class="p-field col-md-4">
        <label for="userType">User Role</label>
        <p-dropdown [options]="usertypeList" formControlName="userType" optionValue="id" optionLabel="name"
          placeholder="Select a User Role" [filter]="true" filterBy="name" class="w-100" appendTo="body">
        </p-dropdown>
      </div>

      <!-- Password Field -->
      <div class="p-field col-md-4" *ngIf="!userForm.get('ad_user')?.value">
        <label for="password">Password</label>
        <div class="p-inputgroup pos-rel">
          <input id="password" [type]="showPassword ? 'text' : 'password'" pInputText formControlName="password"
            maxlength="25" class="w-100" style="padding-right: 2.5rem;" />
          <span class="p-inputgroup-addon p-0 p-input-group-abs"
            style="">
            <button type="button" pButton pRipple icon="pi pi-eye"
              [icon]="showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'" (click)="togglePasswordVisibility()"
              class="p-button-text p-button-plain p-button-sm password-btn" style="color: var(--text-color-secondary);"></button>
          </span>
        </div>
        <div *ngIf="userForm.get('password')?.touched && userForm.get('password')?.invalid" class="p-error mt-1">
          <small class="text-danger" *ngIf="userForm.get('password')?.errors?.['required']">Password is
            required.</small>
          <small class="text-danger" *ngIf="userForm.get('password')?.errors?.['pattern']">Password must include at
            least one uppercase letter, one lowercase letter, one number, and one special character.</small>
        </div>
      </div>
    </div>

    <!-- HRCDF Designation -->
    <div class="row mb-4 mt-4">
      <div class="p-field col-md-4">
        <label for="hrcdf_designation">HRCDF Designation*</label>
        <input id="hrcdf_designation" type="text" pInputText formControlName="hrcdf_designation" maxlength="255" />
        <div *ngIf="userForm.get('hrcdf_designation')?.touched && userForm.get('hrcdf_designation')?.invalid"
          class="p-error mt-1">
          <small class="text-danger" *ngIf="userForm.get('hrcdf_designation')?.errors?.['required']">HRCDF Designation
            is required.</small>
          <small class="text-danger" *ngIf="userForm.get('hrcdf_designation')?.errors?.['pattern']">Invalid HRCDF
            Designation format.</small>
        </div>
      </div>
    </div>

    <!-- Submit Button -->
    <div class="row footer-btn mt-4">
      <button pButton label="Submit" type="submit" [disabled]="userForm.invalid" class="fetch-data-btn"></button>
    </div>
  </form>
</p-dialog>


<p-dialog [header]="viewMode ? 'View User' : 'Edit User'" [(visible)]="showEditUserDialog" [modal]="true"
  [style]="{ width: '800px' }" appendTo="body" [maximizable]="true">

  <form [formGroup]="userForm" (ngSubmit)="editUserDetailsForm()" class="p-fluid form-wrapper">
    <!-- AD User Section -->
    <div class="row mb-4 num-field">
      <div class="p-field-checkbox col-md-2 ad-user">
        <p-checkbox formControlName="ad_user" binary="true" inputId="ad_user" class="custom-checkbox"></p-checkbox>
        <label for="ad_user">AD User</label>
      </div>

      <!-- Phone Field -->
      <div class="p-field col-md-6" *ngIf="userForm.get('ad_user')?.value">
        <label for="phone">Personal Number</label>
        <input id="phone" type="text" pInputText maxlength="10" formControlName="phone" inputmode="numeric"
          pattern="[0-9]*" oninput="this.value = this.value.replace(/[^0-9]/g, '')" />
        <div *ngIf="userForm.get('phone')?.touched && userForm.get('phone')?.hasError('required')" class="text-danger">
          Phone number is required.
        </div>
      </div>

      <!-- Fetch Data Button -->
      <div class="p-field col-md-4" *ngIf="userForm.get('ad_user')?.value">
        <button pButton label="Fetch Data from HRCDF" type="submit" [disabled]="!userForm.get('phone')?.value"
          class="fetch-data-btn" (click)="fetchData()"></button>
      </div>
    </div>

    <!-- Rank Code -->
    <div class="row mt-4">
      <div class="p-field col-md-4">
        <label for="rankCode">Rank Code</label>
        <input id="rankCode" type="text" pInputText formControlName="rankCode" />
        <div *ngIf="userForm.get('rankCode')?.touched && userForm.get('rankCode')?.invalid" class="p-error mt-1">
          <small class="text-danger" *ngIf="userForm.get('rankCode')?.errors?.['required']">Rank Code is
            required.</small>
        </div>
      </div>

      <!-- Rank Name -->
      <div class="p-field col-md-4">
        <label for="rankName">Rank Name</label>
        <input id="rankName" type="text" pInputText formControlName="rankName" />
        <div *ngIf="userForm.get('rankName')?.touched && userForm.get('rankName')?.invalid" class="p-error mt-1">
          <small class="text-danger" *ngIf="userForm.get('rankName')?.errors?.['required']">Rank Name is
            required.</small>
        </div>
      </div>

      <!-- First Name -->
      <div class="p-field col-md-4">
        <label for="first_name">First Name</label>
        <input id="first_name" type="text" pInputText formControlName="first_name" />
        <div *ngIf="userForm.get('first_name')?.touched && userForm.get('first_name')?.invalid" class="p-error mt-1">
          <small class="text-danger" *ngIf="userForm.get('first_name')?.errors?.['required']">First Name is
            required.</small>
        </div>
      </div>
    </div>

    <!-- Last Name -->
    <div class="row mt-4">
      <div class="p-field col-md-4">
        <label for="last_name">Last Name</label>
        <input id="last_name" type="text" pInputText formControlName="last_name" />
        <div *ngIf="userForm.get('last_name')?.touched && userForm.get('last_name')?.invalid" class="p-error mt-1">
          <small class="text-danger" *ngIf="userForm.get('last_name')?.errors?.['required']">Last Name is
            required.</small>
        </div>
      </div>

      <!-- Email -->
      <div class="p-field col-md-4">
        <label for="email">Email</label>
        <input id="email" type="email" pInputText formControlName="email" />
        <div *ngIf="userForm.get('email')?.touched && userForm.get('email')?.invalid" class="p-error mt-1">
          <small class="text-danger" *ngIf="userForm.get('email')?.errors?.['required']">Email is required.</small>
          <small class="text-danger" *ngIf="userForm.get('email')?.errors?.['email']">Invalid email format.</small>
        </div>
      </div>

      <!-- Login Name -->
      <div class="p-field col-md-4">
        <label for="loginname">Login Name</label>
        <input id="loginname" type="text" pInputText formControlName="loginname" />
        <div *ngIf="userForm.get('loginname')?.touched && userForm.get('loginname')?.invalid" class="p-error mt-1">
          <small class="text-danger" *ngIf="userForm.get('loginname')?.errors?.['required']">Login Name is
            required.</small>
        </div>
      </div>
    </div>

    <!-- Unit and User Role -->
    <div class="row mt-4">
      <div class="p-field col-md-4">
        <label for="unit">Unit</label>
        <p-dropdown [options]="unitList" formControlName="unit" optionValue="id" optionLabel="name"
          placeholder="Select a Unit" [filter]="true" filterBy="name" class="w-100" appendTo="body">
        </p-dropdown>
      </div>

      <div class="p-field col-md-4">
        <label for="userType">User Role</label>
        <p-dropdown [options]="usertypeList" formControlName="userType" optionValue="id" optionLabel="name"
          placeholder="Select a User Role" [filter]="true" filterBy="name" class="w-100" appendTo="body">
        </p-dropdown>
      </div>

      <!-- HRCDF Designation -->
      <div class="p-field col-md-4">
        <label for="hrcdf_designation">HRCDF Designation</label>
        <input id="hrcdf_designation" type="text" pInputText formControlName="hrcdf_designation" />
        <div *ngIf="userForm.get('hrcdf_designation')?.touched && userForm.get('hrcdf_designation')?.invalid"
          class="p-error mt-1">
          <small class="text-danger" *ngIf="userForm.get('hrcdf_designation')?.errors?.['required']">HRCDF Designation
            is required.</small>
        </div>
      </div>
    </div>

    <!-- Save Button -->
    <div class="row footer-btn mt-4">
      <button pButton label="Save" type="submit" *ngIf="!viewMode" [disabled]="userForm.invalid || userForm.pristine"
        class="fetch-data-btn"></button>
    </div>
  </form>
</p-dialog>



<p-dialog header="Delete User" [modal]="true" [(visible)]="showDeleteUserDialog" [style]="{ width: '30rem' }"
  [maximizable]="true">
  <div class="delete-dialog mt-3">
    <i class="pi pi-trash text-danger custom-delete-icon"></i>
    <span>Are you sure , you want to delete user ?</span>
    <p-button label="Delete" icon="pi pi-trash" severity="danger" [outlined]="true" (click)="confirmDelete()"
      class="mt-2">
    </p-button>
  </div>
</p-dialog>